import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SpaceXxs, FontSize100 } from "@nxt-costco-com/forge-design-tokens";
import { CustomSingleSkeleton } from "../CustomSingleSkeleton/CustomSingleSkeleton.js";
import { COMPONENT_NAME, MAX_LINES, BORDER_RADIUS_STANDARD } from "../constants.js";
import { SkeletonVariant } from "../enums.js";
const TextMultipleLines = ({
  hiddenText,
  lines,
  width
}) => {
  const widthValue = width ?? "100%";
  const linesValue = lines && lines > MAX_LINES ? MAX_LINES : lines ?? 1;
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: SpaceXxs,
        width: widthValue
      },
      "data-testid": COMPONENT_NAME,
      children: Array.from(Array(linesValue), (_, index) => /* @__PURE__ */ jsx(
        CustomSingleSkeleton,
        {
          height: FontSize100,
          hiddenText,
          sx: {
            borderRadius: BORDER_RADIUS_STANDARD
          },
          variant: SkeletonVariant.Rectangular,
          width: "100%"
        },
        index
      ))
    }
  );
};
export {
  TextMultipleLines
};
